export default __webpack_public_path__ + "static/media/certificate_banner.fb165f82.svg";